//Componentes
require("./themes/componentes/header")

//Vistas
require("./themes/inicio")
require("./themes/contacto")

